import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { GetPatronData, GetPatronGraphDataItem } from '@app/services/patron.service';
import { TabItem } from '@app/shared/tab-view/tab-view.component';
import { trigger, state, style, animate, transition } from '@angular/animations';

const defaultTabs: TabItem[] = [
  {
    id: 'backgroundStatus',
    label: 'Background Status',
  },
];

export type PatronGraphSidePanelMode = 'default' | 'maximized' | 'minimized';

@Component({
  standalone: false,
  selector: 'app-patron-graph-side-panel',
  templateUrl: './patron-graph-side-panel.component.html',
  styleUrls: ['./patron-graph-side-panel.component.css'],
  animations: [
    trigger('panelState', [
      state(
        'default',
        style({
          width: '100%',
        }),
      ),
      state(
        'minimized',
        style({
          width: '0%',
        }),
      ),
      transition('default <=> minimized', [animate('300ms cubic-bezier(0.4,0.0,0.2,1)')]),
    ]),
  ],
})
export class PatronGraphSidePanelComponent {
  @Input() node: any;
  @Input() patron: GetPatronData;
  @Input() selectedApi: GetPatronGraphDataItem | null = null;
  @Input() mode: PatronGraphSidePanelMode = 'default';
  @Output() modeChange = new EventEmitter<PatronGraphSidePanelMode>();

  candidateDetails: Record<string, any> = {};
  apiResponse: Record<string, any> | null = null;
  tabs: TabItem[] = defaultTabs;

  activeTabId: string = defaultTabs[0].id;

  onTabChange(tabId: string): void {
    this.activeTabId = tabId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patron']) {
      this.updateCandidateDetails(this.patron);
    }
    if (changes['selectedApi']) {
      this.updateTabs();
    }
  }

  updateCandidateDetails(user: GetPatronData): void {
    this.candidateDetails = {
      Name: user.name,
      DOB: user.dateOfBirth,
      'Email ID': user.email,
      'Phone Number': user.phoneNumber,
      'Job Name': user.jobName,
      'Ref Id': user.refId,
      'Social Security (ssn)': user.ssn,
      'Driver License': user.driverLicenseNumber,
      'Document Number': user.driverLicenseNumber,
      'BG index code': user.bgIndexCode,
      'Document Type': user.documentType,
      'Assessment Source': user.assessmentSource,
      'DL State': user.dlState,
      City: user.city,
      State: user.state,
      'Postal Code': user.postalCode,
      Address: user.address,
      Department: user.department,
    };
  }

  updateTabs() {
    if (!this.selectedApi) {
      this.tabs = defaultTabs;
      this.activeTabId = defaultTabs[0].id;
      return;
    }

    this.tabs = [
      ...defaultTabs,
      {
        id: 'apiResponse',
        label: this.selectedApi.api_name,
      },
    ];
    this.activeTabId = 'apiResponse';

    this.apiResponse = null;

    try {
      this.apiResponse = JSON.parse(this.selectedApi.response);
    } catch (error) {
      console.error('Error parsing API response:', error);
      this.apiResponse = null;
    }
  }

  onSidebarModeToggle() {
    this.mode = this.mode === 'default' ? 'minimized' : 'default';
    this.modeChange.emit(this.mode);
  }

  onMaximizeToggle() {
    this.mode = this.mode === 'default' ? 'maximized' : 'default';
    this.modeChange.emit(this.mode);
  }
}
